import { Injectable } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import {environment} from '../../../environments/environment.development';
import {filter, map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  constructor(
    private title: Title,
    private router: Router,
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.router.routerState.root;
          while (route.firstChild) route = route.firstChild;
          return route.snapshot.title || 'Default Title';
        })
      )
      .subscribe(title => setTimeout(() => this.setTitle(title), 0)); // setTimeout() is a workaround for a bug in Angular
  }


  setTitle(title: string){
    this.title.setTitle(TitleService.getPrefix() + title + TitleService.getSuffix());
  }

  private static getPrefix(){
    return environment.pageTitle.prefix ? environment.pageTitle.prefix + environment.pageTitle.separator : String();
  }

  private static getSuffix(){
    return environment.pageTitle.separator + environment.pageTitle.suffix;
  }
}
